import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import '../../servicestypes/webdevelopment/webdevservices.css'; // Import the CSS file
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import uiux from '../../../assests/uiux.jpeg';

const Uiuxdesign = () => {
  return (
    <Card className="webdevelopment-card">
      {/* Left side with image */}
      <Grid item xs={12} md={4} className="webdevelopment-image-container">
        <Box
          component="img"
          className="webdevelopment-image"
          alt="UI/UX Design"
          src={uiux}
        />
        
        {/* Contact Information */}
        <div className="contact-info">
          <Typography variant="h6" component="div" gutterBottom className="contact-title">
            Contact Information
          </Typography>
          <div className="contact-item">
            <PhoneIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">+919060237575</Typography>
          </div>
          <div className="contact-item">
            <EmailIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Faridiakram41@gmail.com</Typography>
          </div>
          <div className="contact-item">
            <LocationOnIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Samastipur, Bihar (848101)</Typography>
          </div>
        </div>
        
        {/* Back Button */}
        <Link to="/Services">
          <button className="comic-button">Back</button>
        </Link>
      </Grid>
      
      {/* Right side with content */}
      <Grid item xs={12} md={8} className="webdevelopment-content">
        <CardContent>
          <Typography variant="h4" component="div" gutterBottom className="webdevelopment-title">
            UI/UX Design
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Wireframing and Prototyping:</strong> Creating blueprints and prototypes for websites and apps.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Responsive Design:</strong> Ensuring designs adapt to various screen sizes and devices.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>User Research and Testing:</strong> Conducting user research to inform design decisions and testing for usability.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Interaction Design:</strong> Designing interactive elements that enhance user experience.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Brand Identity Design:</strong> Creating logos, color schemes, and visual identities for brands.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Information Architecture:</strong> Organizing content and navigation for ease of use.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Design Systems:</strong> Developing reusable components and design guidelines for consistency.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Accessibility Design:</strong> Ensuring designs are accessible to all users, including those with disabilities.
          </Typography>
        </CardContent>
      </Grid>
    </Card>
  );
};

export default Uiuxdesign;
